import ExtrachargeIndexVue from "@/views/extracharge/ExtraChargeIndex.vue";

const extracharge = [
    {
        path: '/extracharge',
        name: 'extracharge',
        component: ExtrachargeIndexVue
    }
]

export default extracharge;